<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Gestión de Usuarios</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Gestión de Usuarios</h3>
    </div>

    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Nombre:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Usuario</mat-label>
              <input matInput type="text" placeholder="Nombre" [(ngModel)]="filter.usuario" maxlength="40">
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="filter.idSede">
                <mat-option *ngFor="let item of listaSedes; index as i;"
                  [value]='item.idSede'>{{item.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Correo:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Correo</mat-label>
              <input matInput type="email" placeholder="Correo" [(ngModel)]="filter.correo" maxlength="40">
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Tipo:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Usuario
              </mat-label>
              <mat-select matSelect [(ngModel)]="filter.idTipoUsuario">
                <mat-option [value]='1'>ENGIE</mat-option>
                <mat-option [value]='2'>CONTRATISTA</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Compañía </mat-label>
              <mat-select matSelect [(ngModel)]="filter.idCompania">
                <mat-option *ngFor="let item of listaCompanias; index as i;"
                  [value]='item.idCompania'>{{item.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Estado:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="filter.idEstado">
                <mat-option [value]='0'>Todos</mat-option>
                <mat-option *ngFor="let item of paramsEstados; index as i;"
                  [value]='item.idParametroDetalle'>{{item.valor}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-naranja" mat-raised-button (click)="openDialog()"><mat-icon>description</mat-icon> Agregar
              Usuario</a>
            <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>


      <div class="table-responsive">
        <table mat-table [dataSource]="listaUsuarios" class="table table-striped table-vcenter">
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.nombres + ' ' + element.apellidos }}</td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
          </ng-container>

          <ng-container matColumnDef="correo">
            <th mat-header-cell *matHeaderCellDef>Correo</th>
            <td mat-cell *matCellDef="let element">{{ element.correo }}</td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" (click)="openDialog(element)" aria-label="Editar">
                <mat-icon>create</mat-icon>
              </button>

              <button mat-icon-button *ngIf="element.idEstado == 1" color="primary" aria-label="Deshabilitar"
                (click)="deshabilitar(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>


</div>

<!-- <pre>{{ filter | json}}</pre> -->